import { Component, OnInit } from '@angular/core';
import { ReportManagementService } from '../../services/report-management.service';
import { RoutingService } from '../../../routing/services/routing.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';

@Component({
    selector: 'app-adjustment',
    templateUrl: './adjustment.component.html'
})

export class AdjustmentComponent implements OnInit {

    constructor(private reportManagementService: ReportManagementService, private routingService: RoutingService, private modalService: BsModalService) {
    }

    ngOnInit() {
      this.reportManagementService.resetCategoryStates();
    }

    ngAfterViewInit() {
      setTimeout(() => window.scrollTo(0, 0));
    }

    public get isSaving() {
        return this.reportManagementService.isSaving;
    }

    saveAndNext() {
        this.reportManagementService.saveSectorAdjustments();
        this.reportManagementService.saveManufacturerAdjustments();
        this.reportManagementService.saveSpecificationAdjustments();
        this.routingService.routeToSaveReport();
    }

    viewAdjustments() {
        this.reportManagementService.viewAdjustments();
    }

}



// WEBPACK FOOTER //
// ./src/app/report/adjustments/components/adjustment.component.ts